export default {
  message: {
    hello: '你好 世界'
  },
  header: {
    balance: '余额',
    viewDetails: '查看详情',
    logout: '退出'
  },
  common: {
    close: '关闭',
    search: '搜索',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    form_blank: '此处不可为空白',
    delete_remind: '确定删除吗?',
    no_data: '暂无数据'
  },
  homeRoute: {
    title: '首页'
  },
  home: {
    edit: '修改',
    balance: '账户余额：',
    recharge: '充值',
    credit_line: '授信额度：',
    address: '地址簿',
    receiver: '收件人',
    address_unit: '条',
    manage: '管理',
    shipper: '发件人',
    unpaid_order: '未付款运单',
    suggest_recharge: '建议充值',
    freight: '需充值运费',
    tax: '需充值税费',
    not_billed_order: '未出账运单（单）',
    detail: '查看详情',
    single: '单',
    unpaid_bill: '未付款运单(单)',
    notice_freight: '需充值运费：',
    notice_tax: '需充值税费：',
    notice_title1: '急报！您有',
    notice_title2: '单',
    notice_title3: '宝贝已到仓库，急待出运，',
    notice_title4: '已下单未入库运单，但账户余额不足！',
    notice_result1: '总共',
    notice_suggest_recharge: '建议充值',
    notice_notice_result2: '，或更多，以保证顺利快速的发货。',
    waiting_for_shipping: '查看待发运单',
    notice_recharge: '去充值',
    address_title_receiver: '常用收件人',
    address_title_shipper: '常用发件人',
    address_placeholder: '请输入姓名/电话',
    address_add: '新增地址',
    address_edit: '编辑地址',
    address_name: '姓名',
    address_company: '公司',
    address_tel: '电话',
    address_address: '地址',
    address_tel_message: '请输入数字',
    all_order: '累计下单：',
    order_piece: '单',
    sign: '累计签收：',
    creat_order: '寄件下单',
    order_center: '查看全部',
    import_order: '导入下单',
    order_no: '单号：',
    order_receiver: '收件人：',
    order_station: '运单阶段',
    singed_aging: '签收时段',
    month_statistics: '月签收件签收时效统计',
    date_placeholder: '请选择日期',
    normal_singed: '签收运单',
    signed_later: '签收较晚运单',
    all_sign: '累计签收',
    over_time_signed: '超时签收'
  },
  orderRoute: {
    orders: '订单信息',
    orderDetail: '订单详情',
    myOrders: '我的订单',
    createOrder: '我要下单',
    importOrder: '导入下单',
    receiverTaxUnpaid: '待收税列表',
    senderTaxUnpaid: '待付税列表',
    priceList: '计价规则',
    remoteAreaOrders: '偏远地区运单'
  },
  finacialRoute: {
    finacialStats: '财务管理',
    incomingoutgoings: '收支明细',
    freightstatistics: '运费统计',
    bill: '对账单',
    billDetail: '账单详情'
  },
  userRoute: {
    personal: '用户信息',
    myProfile: '我的资料',
    changePwd: '修改密码',
    recharge: '充值'
  },
  invoiceRoute: {
    invoiceManagement: '发票管理',
    invoiceInformationManagement: '发票信息管理',
    invoiceRequest: '发票索取',
    invoiceList: '发票列表'
  },

  HOME: {
    all_orders: '累计下单',
    all_sign: '累计签收',
    create_order: '寄件下单',
    order_center: '查看全部'
  },
  my_order: '我的订单',
  page_pre: '上页',
  page_next: '下页',
  REGISTER: {
    person_title: '个人注册',
    business_title: '企业用户',
    business_triggle_sign: '企业用户?',
    person_confirm_submit: '确认注册',
    person_registration_intro: '确认注册默认用户已同意',
    protocol_name: '《BUFFALO平台使用协议》',
    person_triggle_sign: '个人注册?'
  },
  LOGIN: {
    login_title: '登录',
    login_btn: '登录',
    welcome: '欢迎来到BUFFALO国际!',
    copyright: 'Copyright © buffaloex.com. All Rights Reserved 沪ICP备17034240号-1',
    conditions: '运输条款',
    privacy_statement: '隐私声明',
    use_terms: '禁止&限制物品',
    LOGIN_OPTION: '登录',
    SIGN_UP_OPTION: '注册',
    USERNAME_PLACEHOLDER: '请输入用户名',
    PASSWORD_PLACEHOLDER: '8-20位，包含数字和字母',
    FORGET_LINK: '忘记密码',
    USERNAME: '用户名',
    PASSWORD: '密码',
    HOME: '首页',
    INTERNATIONAL: '国际'
  },
  FORGET: { SAVE: '提交' },
  forget_password_link: '忘记密码',
  LABEL: {
    phone: '手机',
    phone_placeholder: '请输入手机号',
    phone_btn: '获取验证码',
    code: '验证码',
    code_placeholder: '手机中收到的验证码',
    code_no_input: '请输入验证码',
    password: '密码',
    currency: '结算货币',
    currency_CNY: '人民币(CNY)',
    currency_ZAR: '兰特(ZAR)',
    password_placeholder: '8~20位，包含数字和字母',
    password_input_wrong: '请输入8~20位，包含数字和字母的密码',
    password_original_no_input: '请输入原始密码',
    password_no_input: '请输入密码',
    confirm_password: '确认密码',
    confirm_password_placeholder: '再次输入上面的密码',
    confirm_password_no_input: '请输入确认密码',
    password_input_different: '两次填写密码不一致',
    user_name: '用户名',
    user_name_placeholder: '请输入用户名',
    cellphone_wrong: '请输入正确的手机号码',
    send_success: '发送成功!',
    register_success: '注册成功',
    company_name: '公司名称',
    company_name_placeholder: '请输入公司名称',
    company_short_name_over_length: '公司简称不能超过8个字',
    company_name_alias: '公司简称',
    company_name_alias_placeholder: '请输入公司简称',
    contact_phone: '联系电话',
    contact_phone_placeholder: '请输入联系电话',
    email: '邮箱',
    email_placeholder: '请输入邮箱',
    email_input_wrong: '请输入正确的邮箱',
    invite_code: '邀请码',
    invite_code_placeholder: '请联系BUFFALO商务专员获取',
    your_name: '您的名字',
    your_name_placeholder: '请输入您的名字',
    dynamic_pin: '动态码',
    dynamic_pin_placeholder: '请输入动态码',
    login_fail: '账号或者密码错误',
    login_success: '登录成功',
    customer_helper: '业务客服',
    customer_confirm: '确定',
    main_city: '主要城市',
    city: '城市',
    postcode: '邮编',
    suburb: 'suburb',
    system_error: '系统异常',
    address_placeholder: '邮编,Suburb查询',
    order_no_input: '单号不能为空',
    sign_picture: '签收图',
    confirm_pay_process_start:
      '如果您通过银行转账支付了税款，而订单状态没有更新并继续发货的话，请点击以下链接',
    confirm_pay_process_end: '来上传付款凭证，以再次确认您的付款进度',
    login_placeholder: '用户名/邮箱/手机'
  },
  SEO: {
    register: '注册',
    forget: '忘记密码',
    contact_us: '联系我们',
    login: '登录',
    tracking: '物流轨迹',
    service: '产品服务',
    service_sea: '国际海运 -  产品服务',
    service_air: '国际空运 -  产品服务',
    service_oversea: '海外仓 -  产品服务',
    service_local: '本地派送 -  产品服务',
    about: '关于我们',
    help: '帮助中心',
    index_title:
      'BUFFALO官网 BUFFALO物流 BUFFALO南非专线 BUFFALO南非快递 南非空运快递服务 中国寄南非 南非国际快递专线 南非专线快递 南非快递服务 南非配送 南非专线优势 BUFFALO南非清关 南非电商小包',
    index_description:
      'BUFFALO专业南非快递服务提供商,南非当地拥有土地面积3万5千平米，海关保税仓库6000平米，配送车辆30台，配送用工50名。为中非企业提供中国和非洲之间的快递和海外仓服务，为跨国电子商务提供全程物流解决方案。',
    index_keywords:
      'BUFFALO,南非专线,南非快递,南非清关,南非配送,南非国际快递专线,南非专线快递,南非专线优势,中国寄南非,南非快递服务,南非电商小包'
  },
  index: '主页',
  Orders: '订单信息',
  Order_Center: '我的订单',
  Create_Order: '我要下单',
  'Import Order': '导入下单',
  'Tax Unpaid': '待税收列表',
  'Price List': '计价规则',
  'Pay Tax': '待付税列表',
  'Remote Area Orders': '偏远地区运单',
  Finacial_Stats: '财务管理',
  'Income_&_Expense': '收支明细',
  Cost_Stats: '运费统计',
  Personal_info: '用户信息',
  My_Profile: '我的资料',
  Change_Pwd: '修改密码',
  Recharge: '充值',
  showTitle: '当前显示第 1 至 1 项，共 1 项。',
  OrderCenter: {
    orderStatus: '订单状态',
    order_title: '我的订单',
    'left-title': '订单信息',
    create_time: '下单日期',
    Warehouse_entry_Time: '入库日期',
    form_info: '单号/客户单号/收件人',
    searchContent: '搜索内容',
    clear: '清空',
    search_btn: '查询',
    print_btn: '打印面单',
    export_btn: '导出数据',
    edit_btn: '申报金额和重量导入修改',
    tab_1: '全部订单',
    tab_2: '待付款和入库中',
    tab_3: '运输中',
    tab_4: '已完成',
    Status: '状态',
    Order_No: '单号',
    Reference: '客户单号',
    Logistics: '物流类型',
    Create_Time: '下单日期',
    Warehousing_Time: '入库日期',
    Signed_Time: '签收日期',
    Cosignee: '收件人',
    Destination: '收件地址',
    Box_No: '包件数',
    Tax_pay_status: '是否付税',
    Tax_pay_status_Yes: '是',
    Tax_pay_status_No: '否',
    Estimated_Weight: '下单重量',
    Actual_Weight: '实际重量',
    no_data: '表中数据为空',
    Fright_Charge: '应付运费',
    Tax: '应付税费',
    Total_Amount: '应付总金额',
    notice: '请选择单号',
    tips: ''
  },
  CreateOrder: {
    uploadInvoice: '上传发票',
    uploadPackingList: '上传箱单',
    reUpload: '重新上传',
    uploadTips: '请上传JPG/PNG/PDF文件，大小在10M以内',
    shipperNameTip: 'Supplier信息将用发票填写请仔细填写',
    action: '操作',
    title_1: '下单',
    title_2: '订单信息',
    title_3: '下单',
    General_Info: '基础信息',
    Logistics_type: '物流产品',
    Logistics_type_placeholder: '请选择物品信息',
    Tax_Payer: '税费承担人',
    Storehouse: '揽货仓库',
    Express_No: '物流单号(客户单号)',
    red_tips1: '此处不可空白',
    red_tips: '请务必正确填写物流单号，该号码为BUFFALO集货仓识别包裹唯一识别码。',
    yellow_tips: '注意:',
    yellow_tips_1: '1.请确保实际寄送仓库与所选仓库一致，否则仓库无法完成入库。',
    yellow_tips_2:
      '2.根据国内相关报关口岸的要求，如果选择杭州仓库作为揽货仓库，则还必须填写发件人英文名/发件公司/发件公司英文名，且发件公司必须要拥有出口许可。',
    Consignee_Info: '收件人信息',
    Contact: '常用收件人',
    Consignee_Name: '收件人姓名',
    Company_Name: '收件人公司',
    TEL: '收件人电话',
    TEL1: '发件人电话',
    'E-Mail': '电子邮箱',
    Postal_Code: '邮编',
    Suburb: 'Suburb',
    City: '城市',
    Consignee_Address: '收件人地址',
    notice_1: '详细的收件地址信息,精确到建筑门牌号，不接受任何邮政信箱（PO Box）',
    Consignee_Address2: '收件人地址2',
    notice_2: '对收件地址的描述，可进一步描述收件地址1，如方位，特征等，非必须项',
    Shipper_Info: '发件人信息',
    Common_Info: '常用发件人',
    Shipper_Name: '发件人英文名',
    Company: '发件人公司英文名',
    Company_CN_Name: '发件公司',
    Social_Credit_Code: '社会信用代码',
    Shipper_Address: '发件地址',
    notice_3: '请使用英文填写',
    'Shipper_Address(CN)': '发件地址(中文地址)',
    notice_4: '请使用中文填写',
    Pakage_Description: '包裹物品信息',
    Box: '包裹',
    Chinese_Description: '中文品名',
    Description: '英文品名',
    Quantity: '数量',
    'declaredvalue(USD)': '申报金额(USD)',
    'Magnet/Battery': '带磁带电',
    Action: '操作',
    NO: '否',
    YES: '是',
    Estimate_Weight: '总重量',
    notice_5: '包裹总重量,单位kg',
    Add_item: '添加物品',
    Add_box: '新增包裹',
    Precautions: '注意事项：',
    notice_6:
      '1. 可能产生清关税费、偏远附加费、特殊处理费等其他费用。根据托寄物的不同，有可能在清关环节产生关税，以具体口岸规定为准。',
    notice_7:
      '2. 南非周末和节假日不进行派送。具体派送时效以目的地邮编为准。如遇偏远地区或郊区、航班延误、清关异常等情形，时效会额外增加。',
    notice_8: `3. 更多收费与服务详情，请联系客服热线 400-921-9066 或 邮箱 service@bufflogistics.com。`,
    notice_9: '我已确认阅读并同意',
    notice_10: '《BUFFALO快递运输条款与条件》',
    dialog_title: 'Buffalo快递运输条款与条件 (以下简称“本条款与条件”)',
    title1: '重要提示',
    p1: '当您(以下也称为“发件人”)委托我公司(以下简称“Buffalo”)从事快件运输服务时，您即代表您自身或快件的收件人（“收件人”）或与运单中所称的快件具有利益关系的任何其他方同意适用本条款与条件。 本条款与条件所称快件，是指一份运单下所有的文件或包裹，Buffalo将自行选择空运、陆运或任何其他方式进行该快件的运输。 一份运单应包括Buffalo或发件人电子商务工具所出具的任何货物标识或文件，例如标签、条形码、运单或交货单，及其电子数据形式。 每一快件运输都将适用本条款与条件中关于责任限制的规定。如发件人要求更大程度的保护，可另行投保（有关细节请参看下文）。Buffalo是指Buffalo速递网络的任一成员。',
    title2: '1. 清关',
    p2: 'Buffalo为提供服务可以代表发件人或收件人从事以下事项： （1）填写各类文件，更正产品或服务项目的编码，并按照有关法律法规的要求缴纳关税、税金或罚款（“关税”）；请正确填写“申报金额”，如果因为和付款凭证不符而导致的海关罚款，由发件人承担。 （2）作为发件人的货运代理人办理关税及出口管制的有关手续，并在且仅在于指定报关行完成货物清关入关的手续时作为收件人； （3）应他人要求将承运的货物转交给收件人的报关代理，或运到其它地点，只要Buffalo有合理理由判断该他人已获得必要授权。',
    title3: '2. 不能承运的快件',
    p3_1: ' 有下列情形之一的快件将不予运输： ',
    p3_2: ' • 未能按照有关海关规定办理报关手续； ',
    p3_3: ' • 仿冒品、动物、现钞、宝石；武器、爆炸品、弹药；人体；非法物品，例如象牙制品和麻醉药品； ',
    p3_4: ' • 属于国际航空运输协¬会（IATA）、国际民用航空组织（ICAO）、关于危险货物公路运输的欧洲协定（ADR）或其他有关组织所规定的有害物品、危险物品，以及属于禁运或限运的物品（“危险物品”）； ',
    p3_5: ' • 地址不正确、或表示不恰当，或包装有缺陷或不充足、不能保证在一般注意程度下的安全运输； ',
    p3_6: ' • Buffalo认为不能安全、合法运输的其他任何物品。 ',
    title4: '3. 派送和不能派送',
    p4_1: '快件不能派送到某邮政信箱或仅按邮政编码派送。快件将按发件人提供的收件人地址派送，但不一定直接送达收件人本人。如果收件人地址设有集中接收点，快件将被派送到该接收点。',
    p4_2: '当快件即将派送或未能成功派送时，Buffalo可以通知收件人、并向收件人提供以下可供选择的派送方式，如指定其他日期派送，不需要签名的派送，改址或在Buffalo服务点自提。发件人有权要求排除上述派送方式。',
    p4_3: '有以下情形之一的，Buffalo将以合理的努力将快件退还发件人，因此额外发生的费用由发件人支付：该快件被认为是本条款与条件第2条不能承运的快件； 海关认为发件人低报了货物的价值；无法合理确定或找到收件人；收件人拒绝接收快件或支付关税或快递费。如不能退还，可以对快件进行放弃、处置或变卖， 且不就上述行为向发件人或其他人承担任何责任，所得收入将在扣除关税、快递费、相关管理费以及处理费用后返还发件人。若法律禁止Buffalo将快件退还发件人或快件属于危险物品，则Buffalo有权销毁快件。',
    title5: '4. 查验',
    p5: '出于安全或海关或其他监管机关的要求，Buffalo有权在未通知的情况下对快件进行开封查验。',
    title6: '5. 快递费',
    p6_1: 'Buffalo的运费将按照每件货物实际重量计算标准和体积重量计算标准两者中较高的计算，Buffalo可以对任何一件货物重新称重和测量以确认其计算数据。',
    p6_2: '发件人或收件人（当Buffalo代表收件人时）应向Buffalo支付或返还快递服务中由Buffalo自身收取或代表发件人、收件人所发生的所有快递费、其他费用、关税等税费。在快件派送前，Buffalo有权要求支付关税。',
    p6_3: '若Buffalo代表未在Buffalo开设账号的收件人垫付了关税，Buffalo有权收取相应的服务费。',
    title7: '6. Buffalo的责任',
    p7_1: '6.1 无论《蒙特利尔公约》或《华沙公约》是否适用，Buffalo对任何一票通过空运方式运输（包括快件运输中的陆路运输或中途停靠）的快件的责任应按以下金额低者为限： （i）当前市场价值或申报价值；或（ii）每公斤19特别提款权（约26美元/公斤）。上述责任限制也适用于其他运输方式，除非快件仅通过陆运方式运输，陆运方式的责任限制如下。',
    p7_2: '无论《国际公路货物运输公约》是否适用，Buffalo对以陆运方式运输的国际快件的责任应按以下金额低者为限：（i）当前市场价值或申报价值；或（ii）每公斤8.33特别提款权（约14美元/公斤）。 上述责任限制也适用于国内陆路运输，如果在可适用的国内运输法律中没有规定强制性的或更低的责任限额',
    p7_3: 'Buffalo在任何一票仅在中国境内运输的快件运输中所承担的全部责任都不超过20元人民币/公斤。 若发件人认为上述责任限额不足以补偿其损失，则应对货物的价值作出特别声明并按本条款与条件第8条的规定要求保险或自行投保。',
    p7_4: '对每票快件造成的损害，Buffalo所承担的责任仅限于直接的损失，且不超过本条所规定的每公斤的限额。 Buffalo不承担任何其它损失或损害（包括但不限于利润、收入、利息及未来业务的损失），无论这些其它损失和损害是特殊的或是间接的，无论Buffalo是否知晓存在这些损失或损害的风险。',
    p7_5: '6.2 Buffalo将按照其正常运送标准尽合理努力派送快件，但这些标准并不具有约束力，也不构成协¬议的组成部分。 Buffalo不对运输延误而导致的任何损失或损害承担责任。但针对某些快件，发件人有权根据退款保证条款与条件索赔有限的延误赔偿。',
    title8: '7.索赔时限',
    p8: '任何索赔必须在Buffalo接受快件后的30天内以书面方式向Buffalo提出，否则Buffalo将不再承担任何责任。每票快件只能提出一次索赔，且这种赔偿将作为对有关损失及损害的全部和最终的解决方案。',
    title9: '8. 货物保险',
    p9: '如发件人在运单的正面填好保险项或通过Buffalo的电子商务工具提出代为投保的要求，并支付所需保险费后， Buffalo可以为发件人按照货物的价值就快件的丢失或快件自身的毁损投保。货物保险不包括间接损失或损害，也不包括因运输延误而导致的损失或损害。',
    title10: '9. 不可抗拒因素',
    p10: '对于超出Buffalo控制范围的原¬因而导致的损失或损害，Buffalo不承担责任。 这些原¬因包括但不限于：对于电子音像图片、数据或纪录的电磁性损坏或删除； 快件固有的缺陷或特性(无论Buffalo是否知晓)； 非Buffalo雇员或与Buffalo没有合同关系的人员的作为或不作为， 如发件人、收货人、第三人、海关或其他政府部门；不可抗力，如地震、龙卷风、风暴、洪水、大雾、战争、空难、禁运、暴乱、民间骚乱或劳资事件。',
    title11: '10. 发件人的保证和赔偿责任',
    p11_1: '如发件人违反以下保证和陈述，发件人应赔偿因此而给Buffalo造成的损失和损害：',
    p11_2: '• 发件人或其代理人提供的所有信息都是完整和准确的；',
    p11_3: '• 根据本条款与条件第2条，货物是可承运的；',
    p11_4:
      '• 货物系由可信赖的人员在安全的前提下准备，并确保货物在准备、仓储或运输过程中Buffalo免受他人不当干扰；',
    p11_5: '• 发件人符合有关海关、进出口、数据保护法、制裁、禁运的规定，以及其他法律法规的规定；',
    p11_6:
      '• 为了快件运输、清关和派送，就发件人向Buffalo提供的个人信息，包括收件人信息，例如电子邮件地址和移动电话号码，发件人已经获得所有必要的同意。',
    title12: '11. 路线',
    p12: '发件人接受所有路线和绕航，包括可能的运输中转站。',
    title13: '12. 法律适用和争议解决',
    p13: '考虑到Buffalo的利益，除与所适用法律冲突，与本条款与条件有关的一切争议将受到快件原发件地国法院的非排他管辖，并适用原发件地国法律，发件人不可撤销地接受该管辖。',
    title14: '13. 可分割性',
    p14: '本条款与条件任何部分的无效或不可执行，不影响其他条款的效力和执行。',
    date: '2018年8月13日',
    close: '关闭',
    Order: '下单',
    notice_11: '请填写寄送到BUFFALO仓库的快递单号',
    receive: '常用收件人',
    send: '常用发件人',
    contact_name: '姓名',
    contact_company: '公司',
    contact_tel: '电话号码',
    contact_address: '地址'
  },
  orderList: {
    balance: '当前余额',
    creditline: '授信额度',
    fee: '下单未入库金额（运费+税费）',
    Minimun: '最小充值',
    Suggest: '建议充值'
  },
  orderBulk: {
    explain:
      '亲爱的BUFFALO客户，南非海关法规要求您提供国际订单的发票。请上传这些订单的发票，否则无法创建订单。',
    tips: '请确保余额充足，否则可能影响仓库出货',
    currentlyAvailableCredit: '当前可用授信额',
    totalEstimatedCost: '总计运单预估费用',
    currentBalance: '当前余额',
    OrderedSuccess: '下单成功!',
    Dispatch_Selflifting: '派送/自提',
    title_1: '导入下单',
    title_2: '订单信息',
    label_type: '发货类型',
    large_cargo: '大货明细类型',
    label_Tax: '税费负担人',
    receiver: '收件人',
    sender: '发件人',
    No_Data: '暂无数据',
    label_Warehouse: '转运仓库',
    label_Currency: '申报货币',
    import: '选择文件',
    download: '下载模板',
    list_Fail: '失败列表',
    NOtice_1: '说明：错误数据将导致整个文件',
    NOtice_2: '所有运单导入失败,',
    NOtice_3: '请检查后重新导入',
    Line_No: '行号',
    Error_reason: '失败原因',
    Notice_4:
      '提示：如果不清楚失败记录的处理方法，请致电我司客服400-921-9066 或 邮箱 service@bufflogistics.com ',
    list: '失败列表'
  },
  taxIndex: {
    title_1: '待收税列表',
    title_2: '订单信息',
    All: '所有',
    label_1: '清关完成天数',
    value_1: '所有',
    value_2: '1~3 天',
    value_3: '3~7 天',
    value_4: '7天以上',
    Consignee: '收件人',
    Tel: '收件人电话',
    Order_No: '运单号',
    Notified_Times: '推送次数',
    more: '3以上',
    search: '查询',
    Times_Notified: '推送次数',
    export: '导出',
    Processing_Record: '处理轨迹',
    Cleared_Time: '清关完成日期',
    Destination: '收件人地址',
    Parcel_Description: '英文品名',
    Total_Values: '申报价值',
    'Total_Amount(zar)': '总金额(USD/ZAR)'
  },
  price: {
    logisticsType: '物流类型',
    Transfer_warehouse: '国内转运仓',
    Zone_Code: '派送区域编号',
    title_1: '计价规则',
    title_2: '订单信息',
    Freight: '运费',
    Overseas_warehouse: '海外仓',
    description_download: '派送区域编号说明下载',
    description_costs: '燃油附加费',
    Weight_Section: '重量(KG)',
    First_Unit_Weight: '首重计量基数(KG)',
    First_Unit_Price: '首重单价',
    Additional_Unit_Weight: '续重计量基数(KG)',
    Additional_Unit_Price: '续重单价',
    Discount: '折扣(%)',
    Update_Time: '更新时间',
    Action: '操作'
  },
  taxpayexpress: {
    Pay_Tax: '付税',
    title_1: '待付税列表',
    title_2: '订单信息',
    Order_NO: '运单号',
    Pay_status: '是否付税',
    status: '状态',
    Cleared_Time: '清关日期',
    Confirm_status: '确认状态',
    Order_no: '运单号',
    Sign_Time: '签收日期',
    Sender: '发件人',
    'Total_Amount(zar)': '税费(ZAR)',
    Action: '操作'
  },
  remoteareaorder: {
    Create_Time: '下单时间',
    title_1: '偏远地区运单',
    title_2: '订单信息',
    status_1: '全部状态',
    status_2: '未确认',
    status_3: '已确认',
    Order_NO: '运单号',
    search: '查询',
    export: '导出',
    Action: '操作',
    Time: '时间',
    Confirmation_Status: '确认状态',
    Order_Status: '运单状态',
    City: '城市',
    Post_Code: '邮编',
    Suburb: 'Suburb',
    'Consignee/Tel': '收件人/电话'
  },
  Customer_Bill: {
    title_1: '对账单',
    title_2: '财务管理',
    Billed: '已出账单',
    Unbilled: '未出账单',
    All_Paystatus: '全部',
    // All_Paystatus: 'All Paystatus',
    Unpaid: '未付款',
    Paid: '已付款',
    Partpaid: '部分付款',
    Title: 'Title',
    Payment_status: '支付状态',
    Quantity_of_order: '订单数量',
    Bill_Amount: '账单金额',
    Adjustment_amount: '调整金额',
    Confirmed_Amount: '确认金额',
    Reason_for_Adjustment: '调整原因',
    Founder: '创建人',
    Date: '日期',
    Modified_by: '修改人',
    Modified_time: '修改时间',
    Action: '操作',
    Waybill_Details: '运单明细',
    Overseas_Warehouse: '海外仓',
    button_1: '订单数',
    button_2: '运费',
    button_3: '税费',
    button_4: '其他',
    button_5: '海外仓操作费',
    button_6: '海外仓储存费',
    Time: '时间',
    Waybill_No: '运单号',
    Customer_order_No: '客户单号',
    City: '城市',
    Post_Code: '邮编',
    Suburb: 'Suburb',
    Area: '区域',
    chargeable_Weight: '计费重量',
    total_Shipping: '总运费',
    total_Tax: '总税费',
    other: '其他(退货/销毁费)',
    type: '类型',
    number_of_Parcels: '件数',
    weight: '重量(KG)',
    volume: '体积(CBM)',
    fee: '费用(CNY)',
    exportBillDetail: '订单明细导出',
    exportOverseasDetail: '海外仓明细导出'
  },
  freightstatistics: {
    detail: '详情',
    title_1: '运费统计',
    title_2: '财务管理',
    search: '查询',
    export: '导出',
    label_1: '订单数',
    label_2: '总重量(KG)',
    label_3: '总运费',
    label_4: '总税费',
    label_5: '总费用',
    Date: '下单日期',
    Time: '时间',
    Order_No: '运单号',
    Customer_No: '客户单号',
    Status: '订单状态',
    Boxs: '箱数',
    City: '城市',
    Postcode: '邮编',
    Suburb: 'Suburb',
    Area: '计费区域',
    Final_Weight: '计费重量(KG)',
    Freight_Charge: '总运费',
    Tax: '总税费',
    Amount: '总费用',
    Action: '操作',
    Price: '单价',
    Freight_Charge1: '运费',
    Operation_Fe_: '操作费',
    Magnet_Battery_Fee_: '带磁带电费'
  },
  user_info: {
    no_recharge: '未确认充值',
    date: '日期',
    save: '保存',
    cancel: '取消',
    ok: '确定',
    title_1: '我的资料',
    title_2: '客户信息',
    tab_1: '个人信息',
    tab_2: 'Importers信息',
    shipper_Info: 'Supplier信息',
    shipper_Info_describe:
      '该Shipper信息将用于您的运单清关和Invoice抬头，请谨慎填写，若有疑问可联系客服。',
    label_1: '姓名 :',
    label_2: '用户名 :',
    label_3: '邮箱 :',
    label_4: '手机 :',
    label_5: '公司 :',
    label_6: '公司简称 :',
    label_7: '退货地址 :',
    label_8: '授信额度 :',
    label_9: '帐户余额 :',
    label_10: 'Name :',
    label_11: 'ID :',
    label_12: 'Importers Code :',
    label_13: 'Address :',
    label_14: 'Cellphone :',
    edit: '修改',
    editEmail: '修改邮箱',
    editPhone: '修改手机',
    userChargeTip: '您的当前账户存在未确认充值订单 日期',
    sendPin: '发送验证码到',
    code: '验证码',
    getCode: '获取验证码',
    newPhone: '新号码',
    upateSuccess: '更新成功!',
    curPhone: '当前手机',
    lessThan50Chars: '请输入不超过50字的内容',
    need13Digitals: '请输入13位数字',
    need6_8Digitals: '请输入6~8位数字',
    lessThan400Chars: '请输入不超过400字的内容',
    max5Files: '最多只能上传5个文件',
    canotSupportFile: '不支持该文件格式',
    moreThan0: '请输入大于0的数字',
    uploadProff: '请上传支付凭证'
  },
  changepwd: {
    title_1: '我的资料',
    title_2: '客户信息',
    label_1: '原始密码 :',
    label_2: '新密码 :',
    label_3: '确认密码 :',
    label_4: '原始密码(必填)',
    label_5: '新密码(必填)',
    label_6: '确认密码(必填)',
    save: '保存',
    verify_type: '验证方式 :',
    pwd_verify: '密码验证',
    yzm_verify: '验证码验证',
    telephone: '手机号码',
    code: '验证码',
    get_code: '获取验证码',
    getCodeFirst: '请获取验证码',
    go_to_profile: '去完善',
    verification_code: '请输入验证码',
    no_bind_telephone: '尚未绑定手机，请完善手机号'
  },
  invoiceInfo: {
    title_1: '发票信息管理',
    title_2: '发票管理',
    label_1: '发票抬头 :',
    label_2: '开具类型 :',
    label_3: '发票类型 :',
    label_4: '税务登记证号 :',
    label_5: '开户银行 :',
    label_6: '开户账号 :',
    label_7: '注册场所地址 :',
    label_8: '注册场所电话 :',
    label_1_placeholder: '发票抬头',
    label_2_placeholder: '开具类型',
    label_3_placeholder: '发票类型',
    label_4_placeholder: '税务登记证号',
    label_5_placeholder: '开户银行',
    label_6_placeholder: '开户账号',
    label_7_placeholder: '注册场所地址',
    label_8_placeholder: '注册场所电话',
    save: '提交审核',
    enterprise: '企业',
    auditing: '发票信息正在审核中，请耐心等待。',
    auditFailed: '发票信息未审核通过，未通过理由*********！',
    auditSuccess: '审核通过！',
    cannotBeNull: '此处不可空白'
  },
  getInvoiceIndex: {
    title_1: '发票索取',
    title_2: '发票管理',
    type: '类型',
    amount: '金额（元）',
    operation_Date: '操作日期',
    total: '合计 :',
    totalAmount: '合计金额',
    button: '索要发票',
    checkRecords: '请勾选记录',
    invoiceInfoConfirm: '开票信息确认',
    invoiceTitle: '发票抬头',
    doInvoiceType: '开具类型',
    invoiceType: '发票类型',
    vatSpecialInvoice: '增值税专用发票',
    valueAddedTaxInvoice: '增值税普通发票',
    invoiceAmount: '开票金额',
    taxPayment: '支付税额',
    taxRegistCertNo: '税务登记证号',
    bankName: '开户银行名称',
    accountNo: '开户账号',
    registeredAddress: '注册场所地址',
    registeredTel: '注册场所电话',
    invoiceShippingAddress: '发票寄送地址',
    invoiceContact: '发票联系人',
    close: '关闭',
    submit: '提交',
    ok: '确定',
    enterprise: '企业',
    receiver: '请输入收件人',
    receiverAddress: '请输入收件人地址'
  },
  invoiceOrderIndex: {
    title_1: '发票列表',
    title_2: '发票管理 ',
    label_1: '已开票',
    Type: '状态',
    Date_Created: '创建日期',
    Invoice_amount: '发票金额',
    Tax: '税额',
    Invoice_Shipping_Address: '发票寄送地址',
    Invoice_Contact: '发票联系人',
    all: '全部',
    payTax: '支付税额',
    unPay: '待付款',
    toBeInvoiced: '待开票',
    Operate: '操作'
  },
  incomingoutgoings: {
    title_1: '收支明细',
    title_2: '财务管理',
    Order_NO: '运单号',
    inputOrderNoReceiver: '请输入运单号',
    balance: '余额',
    detail: '详情',
    amount: '总金额',
    storageDetail: '仓租费详情',
    totalVolume: '合计计费体积(CBM)',
    volume: '体积(CBM)',
    fee: '费用(CNY)',
    productName: '品名',
    storageAge: '库龄',
    close: '关闭',
    search: '查询',
    orderDate: '下单日期',
    tradeTypes: {
      allTradeType: '全部交易类型',
      recharge: '充值',
      refund: '退款',
      compensation: '赔偿',
      payFreight: '付运费',
      freightDifference: '付运费差',
      returnDifference: '退运费差',
      returnCharges: '退运费',
      secondDeliveryFee: '二次派送费',
      payTaxes: '付税费',
      specialClearanceFee: '特殊物品清关费',
      prepaidTax: '预付税费',
      refundPrepaidTax: '预付税费返还',
      returnDestructionFee: '付退货/销毁费',
      overseasStorageCharge: '海外仓仓储费',
      overseasWarehouseHandleFee: '海外仓操作费',
      overseasWarehouseHandleReturnFee: '海外仓操作费退款',
      overseasWareInBoundFee: '海外仓入库费',
      overseasWareInBoundReturnFee: '海外仓入库费返还',
      bankServiceCharge: '银行手续费',
      remoteAreaCharge: '偏远地区费用',
      other: '其它'
    },
    Search: '查询',
    Export: '导出',
    label_1: '明细',
    label_2: '汇总',
    Date: '日期',
    Time: '时间',
    Transaction_Type: '类型',
    Reason: '变更详情',
    Recharge_Type: '充值来源',
    Remark: '说明',
    Order_No: '运单号',
    Customer_No: '客户单号',
    Number: '件数',
    City: '城市',
    Postcode: '邮编',
    Suburb: 'Suburb',
    Zone: '计费区域',
    Weight: '计费重量(KG)',
    Amount: '总金额(ZAR)',
    Balance: '账户余额(ZAR)',
    Declared: '申报价值',
    Action: '操作',
    type_2: '交易类型',
    total: '总金额'
  },
  orderDetail: {
    costTip: '退货快递费用，具体金额以第三方快递公司实际收费为准',
    refundTip:
      '国内中转仓出库前取消订单, 运费全额退款, 余额客户退款将返还至客户余额账户中, 账期客户此笔运单费用记账为0, 若运单已进行账期结算, 将于下期账单中扣除',
    refundAmount: '退款金额',
    destroyTip: '客户悉知：销毁包裹操作无法撤销，请谨慎操作',
    destroy: '销毁',
    returnGoods: '退货',
    orderState: '订单状态',
    cancelOrder1: '取消订单',
    saveChanges: '保存修改',
    change: '修改',
    applyModification: '申请修改',
    placeholder: '请选择',
    cancel: '取消',
    confirm: '确认',
    pleaseInput: '请输入',
    cancelOrder: '取消订单',
    receiver: '收件人',
    sender: '发件人',
    Detail_Name1: '基本信息',
    Detail_Name2: '收件人信息',
    Detail_Name3: '发件人信息',
    Detail_Name4: '收费信息',
    Detail_Name5: '详细信息',
    Detail_Name6: '物流轨迹',
    Order_No: '运单号',
    Order_Time: '下单时间',
    'B/L_No': '提单号',
    Freight_Charge_Status: '运费支付状态',
    Order_Status: '订单状态',
    Customer_No: '客户单号',
    Last_Update: '更新时间',
    Tax_Burden: '税费负担',
    Tax_Status: '稅费支付状态',
    MagnetBattery: '带磁带电',
    Clearance_Status: '清关状态',
    'Deliver/Self-Collect': '派送方式',
    Collection_PIN: '自提取件码',
    Logistics: '物流类型',
    Actual_Weight: '确认重量/体积重量',
    Final_Weight: '计费重量/运费',
    BAF: '燃油附加',
    Operation_Fee: '操作费',
    'Magnet/Battery_Fee': '带磁带电费',
    Total_Freight_Charge: '运费总计',
    Estimated_Weight: '预估重量/预估运费总计',
    Chg_Tax: '应付税费',
    Tax_Paid: '实付税费',
    COD: '代收货款',
    Extra_Clearance_Fee: '额外清关费用',
    Extra_Logistics_Fee: '额外物流费用',
    Box_No: '箱号',
    Estimated_W: '申报重量',
    Actual_W: '确认重量',
    Weight_by_Volume: '确认体积重',
    'L*W*H': '长*宽*高',
    Chinese_Description: '品名',
    EN_Description: '英文品名',
    Description: 'Name',
    HSCode: 'HSCode',
    Numbers: '数量',
    Declare_Value: '申报价值',
    Company: '公司名称',
    Receiver: '收件人姓名',
    Receiver_Telephone: '收件人电话',
    Address: '收件人地址',
    Address2: '收件人地址2',
    City_Town: '城市/镇',
    Postcode_Suburb: '邮编',
    Email: '邮箱',
    Area: '区域',
    Transit_depo: '转运 地址',
    Company_CN: '公司名称（中文）',
    Company_EN: '公司名称（英文）',
    Sender: '发件人姓名',
    Telephone: '发件人电话',
    Sender_city: '发件人城市',
    Sender_Address: '发件人地址',
    'Sender_Address(CN)': '发件人地址（中文）',
    'PostCode/Suburb': '邮编/Suburb',
    Sender_Area: '区域'
  },
  recharge: {
    text: '充值请求已收到，将在1天内进行确认，加入您的余额。确认后将发邮件通知您。',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    rechargeText: '充值',
    rechargeSuccess: '充值成功',
    rechargeFail: '充值失败',
    serviceFee: '手续费',
    submit: '提交',
    uploadProff: '请上传支付凭证'
  },
  searchContent: '搜索内容'
}
